import 'src/global.css';

// ----------------------------------------------------------------------

import { Router } from 'src/routes/sections';

import { useScrollToTop } from 'src/hooks/use-scroll-to-top';

import { LocalizationProvider } from 'src/locales';
import { I18nProvider } from 'src/locales/i18n-provider';
import { ThemeProvider } from 'src/theme/theme-provider';

import { Snackbar } from 'src/components/snackbar';
import { ProgressBar } from 'src/components/progress-bar';
import { PwaPrompts, PwaProvider } from 'src/components/pwa';
import { MotionLazy } from 'src/components/animate/motion-lazy';
import { SettingsDrawer, defaultSettings, SettingsProvider } from 'src/components/settings';

import { AuthProvider as JwtAuthProvider } from 'src/auth/context/jwt';
import { ReauthenticationDialog } from 'src/auth/components/reauthentication-dialog';

// ----------------------------------------------------------------------

export default function App() {
  useScrollToTop();

  return (
    <I18nProvider>
      <LocalizationProvider>
        <JwtAuthProvider>
          <SettingsProvider settings={defaultSettings}>
            <ThemeProvider>
              <PwaProvider>
                <MotionLazy>
                  <Snackbar />
                  <PwaPrompts />
                  <ReauthenticationDialog />
                  <ProgressBar />
                  <SettingsDrawer />
                  <Router />
                </MotionLazy>
              </PwaProvider>
            </ThemeProvider>
          </SettingsProvider>
        </JwtAuthProvider>
      </LocalizationProvider>
    </I18nProvider>
  );
}
